var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgWallet(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16 5.5C17.0938 5.5 18 6.40625 18 7.5V15C18 16.125 17.0938 17 16 17H5C3.3125 17 2 15.6875 2 14V6C2 4.34375 3.3125 3 5 3H14C15.0938 3 16 3.90625 16 5V5.5ZM16.5 15V7.5C16.5 7.25 16.25 7 16 7H5.5C5.21875 7 5 6.78125 5 6.5C5 6.25 5.21875 6 5.5 6H14.5V5C14.5 4.75 14.25 4.5 14 4.5H5C4.15625 4.5 3.5 5.1875 3.5 6V14C3.5 14.8438 4.15625 15.5 5 15.5H16C16.25 15.5 16.5 15.2812 16.5 15ZM14 10C14.5312 10 15 10.4688 15 11C15 11.5625 14.5312 12 14 12C13.4375 12 13 11.5625 13 11C13 10.4688 13.4375 10 14 10Z",
    fill: "#0A0A0B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWallet);
export default __webpack_public_path__ + "static/media/wallet.65ca25a834533ee3e1ee0ada6785a2cc.svg";
export { ForwardRef as ReactComponent };